import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';

interface Props {
  isApplySubNavSpace?: boolean;
}

const NavigationWrapper = styled.div<Props>`
  display: none;
  ${mobile_xl(css<Props>`
    display: flex;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--background-primary);
    position: fixed;
    bottom: 0;
    z-index: 11;
    width: -webkit-fill-available;
    border-top: 0.5px solid var(--border-primary);
    ${(props: Props) =>
      props.isApplySubNavSpace &&
      css`
        margin-inline: -20px;
        width: calc(100vw - 20px);
      `}

    &.apply-zindex {
      z-index: 1111;
    }
    ${(props: Props) =>
      props.isApplySubNavSpace &&
      css`
        margin-inline: -20px;
        width: calc(100vw - 20px);
      `}
  `)}
`;

const NavigationItem = styled.div<{ disabled?: boolean }>`
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .plus-icon {
    path {
      fill: var(--text-tertiary);
    }
  }
  .active {
    path {
      fill: var(--text-primary);
    }
  }
  .active-stroke {
    path {
      fill: var(--text-primary);
    }
  }
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
    `}
`;
export { NavigationWrapper, NavigationItem };
